var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-health-container"},[_c('a-spin',{attrs:{"spinning":_vm.spinning}},[(_vm.chartData.length)?_c('bar-chart-usage-top',{attrs:{"unit":"分","chart-data":_vm.chartData,"bar-color":_vm.barColor,"bg-color":_vm.bgColor,"height":260,"eventList":[
        {
          type: 'element:click',
          func: _vm.chartClick
        }
      ],"chart-id":"virtual-machine-storage-usage-chart"}}):_c('div',{staticStyle:{"min-height":"264px","position":"relative","overflow":"hidden"}},[_c('empty-component',{attrs:{"description":"暂无数据","imgUrl":require('@/assets/images/info_empty.png'),"body-style":{
          height: '176px',
          marginTop: '28px'
        },"description-style":{
          marginTop: '-24px'
        }}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }